import { ButtonDS, CheckOutlined, hasIbanFormat, InputDS } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useCallback, useState } from "react";
import styled from "styled-components";
import "../../../i18n/i18n";

type ExternalIbanInputProps = {
  setIsExternalIbanModalVisible: (value: boolean, iban: string) => void;
};

export const ExternalIbanInput = (props: ExternalIbanInputProps) => {
  const { t } = useTranslation();
  const [newExternalIban, setNewExternalIban] = useState<string>("");
  const [displayError, setDisplayError] = useState<boolean>(false);

  const clickToSubmit = useCallback(() => {
    setDisplayError(true);
    if (!newExternalIban) return;
    hasIbanFormat(newExternalIban) &&
      props.setIsExternalIbanModalVisible(true, newExternalIban) &&
      setDisplayError(false);
  }, [newExternalIban, props]);

  return (
    <StyledRow>
      <InputDS
        error={
          displayError && !newExternalIban
            ? t("companyFollowUp.externalIban.input.error.empty")
            : displayError && newExternalIban && !hasIbanFormat(newExternalIban)
              ? t("companyFollowUp.externalIban.input.error")
              : undefined
        }
        placeholder={t("companyFollowUp.externalIban.input.placeholder")}
        value={newExternalIban}
        onKeyDown={(e) => e.key === "Enter" && clickToSubmit()}
        onChange={(e) => setNewExternalIban(e.target.value)}
        withoutSpacerBottom
      />
      <ButtonDS
        singleIcon={{ icon: <CheckOutlined />, size: "S" }}
        format="fill"
        buttonType="primary"
        onClick={clickToSubmit}
      />
    </StyledRow>
  );
};

const StyledRow = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;
